import { Button } from '@billy/design-system'
import { ReactPortal } from 'react'
import { createPortal } from 'react-dom'
import { useTranslation } from 'react-i18next'

import { importedInvoicePaymentStatusToVariant } from '../../../../../../constants/importedInvoicePaymentStatusToVariant'
import { ImportedInvoicePaymentStatus } from '../../../../../../types/importedInvoicePaymentStatus'
import { useImportedInvoiceDrawerActionsElement } from '../../../../context/importedInvoiceDrawerActions'

interface ImportedInvoicePaymentActionButtonProps {
  paymentStatus: ImportedInvoicePaymentStatus
}

/** Shown in the drawer header. Disabled until payments can be registered or voided from here. */
export const ImportedInvoicePaymentActionButton = ({
  paymentStatus,
}: ImportedInvoicePaymentActionButtonProps): ReactPortal | null => {
  const { t } = useTranslation()
  const actionsElement = useImportedInvoiceDrawerActionsElement()

  const { actionKey, actionVariant } = importedInvoicePaymentStatusToVariant[paymentStatus]

  if (!actionsElement) {
    return null
  }

  return createPortal(
    <Button disabled variant={actionVariant}>
      {t(actionKey)}
    </Button>,
    actionsElement,
  )
}
